import React from 'react';

const PixelIdInstructions = ({platform}) => {
  switch (platform){
    case 'facebook':
    case 'instagram':
      return <div className="pixel-platform-instructions">
        <h5>How to get Facebook / Instagram pixel id: </h5>
        <ol>
          <li>Create <a href="https://www.facebook.com/ads/manager/" target="_blank" rel="noopener noreferrer">Facebook Ad Account</a>. (Please login with your facebook account if needed)</li>
          <li>Visit <a href="https://www.facebook.com/events_manager/" target="_blank" rel="noopener noreferrer">Events Manager</a></li>
          <li>No pixel yet? Click <strong>Create a pixel,</strong> then <strong>Create,</strong> and then <strong>Close</strong> the popup</li>
          <li>Copy the <strong>Pixel ID</strong> on this page to Shor</li>
        </ol>
          
        <div><img src="/img/fb-pixel-copypaste.png" alt="" width="100%" className="mt-3" /></div>
      </div>
    case 'adwords':
      return <div className="pixel-platform-instructions">
        <h5>How to get Adwords / Youtube pixel id: </h5>
        <ol>
          <li>Create <a href="https://adwords.google.com/" target="_blank" rel="noopener noreferrer">Google Ad Account</a></li>
          <li>Visit <a href="https://adwords.google.com/aw/audiences/management/datasources" target="_blank" rel="noopener noreferrer">Audience manager</a></li>
          <li>No pixel yet? Click <strong>Set up tag,</strong> select <strong>Collect standard data…</strong>, press <strong>Continue</strong>, and then <strong>Done</strong></li>
          <li>In the AdWords tag card, click <strong>Details</strong> and expand <strong>Adwords tag</strong> section</li>
          <li>Copy <strong>Conversion ID</strong> from this code to Shor</li>
        </ol>
        
        <div>gtag('config', '<span className="badge badge-light">AW-123456733</span>');</div>
      </div>
    case 'twitter':
      return <div className="pixel-platform-instructions">
        <h5>How to get Twitter pixel id: </h5>
        <ol>
          <li>Create <a href="https://ads.twitter.com/login" target="_blank" rel="noopener noreferrer">Twitter Ad Account</a></li>
          <li>Select <strong>Tools</strong> tab then press <strong>Conversion Tracking</strong></li>
          <li>No pixel yet? <strong>Click Generate website tag…</strong> and then <strong>Return to conversion tracking</strong></li>
          <li>Copy <strong>Website Tag ID</strong> on this page to Shor</li>
        </ol>
        
        <div>Website Tag ID: <span className="badge badge-light">nt6r7</span></div>
      </div>
    case 'pinterest':
      return <div className="pixel-platform-instructions">
        <h5>How to get Pinterest pixel id: </h5>
        <ol>
          <li>Create <a href="https://ads.pinterest.com/" target="_blank" rel="noopener noreferrer">Pinterest Ad Account</a></li>
          <li>Select <strong>Ads</strong> tab then <strong>Conversion Tracking</strong></li>
          <li>No pixel yet? Click <strong>Generate Pinterest</strong> tag then press <strong>Done</strong></li>
          <li>Copy <strong>Unique Tag ID</strong> on this page to Shor</li>
        </ol>
        
        <div>Unique Tag ID: <span className="badge badge-light">1621052432415</span></div>
      </div>
    case 'linkedin':
      return <div className="pixel-platform-instructions">
        <h5>How to get LinkedIn pixel id: </h5>
        <ol>
          <li>Create <a href="https://www.linkedin.com/ad/" target="_blank" rel="noopener noreferrer">LinkedIn Ad Account</a></li>
          <li>Select <strong>Account assets</strong> tab and then <strong>Insight tag</strong></li>
          <li>Copy <strong>Partner ID</strong> from this code to Shor</li>
        </ol>
    
        <div>_linkedin_data_partner_id = &quot;<span className="badge badge-light">205987</span>&quot;;</div>
      </div>
    case 'quora':
      return <div className="pixel-platform-instructions">
        <h5>How to get Quora pixel id: </h5>
        <ol>
          <li>Create <a href="https://www.quora.com/business" target="_blank" rel="noopener noreferrer">Quora Ad Account</a></li>
          <li>Select <strong>Quora Pixel</strong> tab and click <strong>Setup Pixel</strong></li>
          <li>Copy <strong>Init ID</strong> from this code to Shor, click <strong>Continue</strong> then <strong>Done</strong></li>
        </ol>
        
        <div>qp('init', '<span className="badge badge-light">eb4173c0577a487998a3cea21eaa3ae6</span>');</div>
      </div>
    case 'snapchat':
      return <div className="pixel-platform-instructions">
        <h5>How to get Snap Pixel id:</h5>
        <ol>
          <li>Log in to Snapchat <a href="http://ads.snapchat.com/" target="_blank" rel="noopener noreferrer">Ads Manager</a></li>
          <li>Click the menu in the top corner and select Snap Pixel.</li>
          <li>Click Create my Snap Pixel.</li>
          <li>Copy <strong>Pixel ID</strong> from this code to Shor</li>
        </ol>
        
          <div>snaptr('init', '<span className="badge badge-light">xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</span>'</div>
      </div>
    case 'gtm':
      return <div className="pixel-platform-instructions">
        <h5>How to get Google Analytics pixel id: </h5>
        <ol>
          <li>Create <a href="https://analytics.google.com/analytics/" target="_blank" rel="noopener noreferrer">Google Analytics account</a></li>
          <li>Click <strong>Create account</strong> button and then <strong>Get Tracking ID</strong></li>
          <li>Copy <strong>Tracking ID</strong> from this code to Shor</li>
        </ol>
          
        <div>gtag('config', '<span className="badge badge-light">UA-000000</span>');</div>
      </div>
    default:
      return null;
  }
}
    

export default PixelIdInstructions;


// WEBPACK FOOTER //
// ./src/components/PixelSets/PixelIdInstructions.js